export const UI_STATE_FIELDS_TO_FORM_STATE_MAP = {
  cvv: 'cardCvv',
  dob: 'dateOfBirth',
  expiry: 'cardExpiry',
} as const;
